import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const outHowApi = createApi({
  reducerPath: "outHowApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_DEV_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().user.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getOutHow: builder.query({
      query: () => ({
        url: `wicketType`,
      }),
    }),
  }),
});

export const { useGetOutHowQuery } = outHowApi;
